import React from 'react';
import { useTheme } from '../components/ThemeContext';
import { Building2 } from 'lucide-react';

const Institutions: React.FC = () => {
    const { theme } = useTheme();

    const bgBase = theme === 'dark' ? 'bg-gray-900' : 'bg-white';
    const textPrimary = theme === 'dark' ? 'text-white' : 'text-gray-900';
    const textSecondary = theme === 'dark' ? 'text-gray-400' : 'text-gray-600';
    const cardBorder = theme === 'dark' ? 'border-gray-700' : 'border-gray-200';
    const cardBg = theme === 'dark' ? 'bg-gray-800' : 'bg-white';

    return (
        <div className={`min-h-screen ${bgBase}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center gap-3 mb-3">
                        <div className="p-3 rounded-xl bg-blue-500/10">
                            <Building2 className="w-8 h-8 text-blue-500" />
                        </div>
                        <div>
                            <h1 className={`text-3xl font-bold ${textPrimary}`}>Institutional Ownership</h1>
                            <p className={`text-sm ${textSecondary} mt-1`}>
                                Track institutional holdings, ownership changes, and fund activity
                            </p>
                        </div>
                    </div>
                </div>

                {/* Placeholder Content */}
                <div className={`border ${cardBorder} ${cardBg} rounded-xl p-8`}>
                    <div className="text-center">
                        <Building2 className={`w-16 h-16 mx-auto mb-4 ${textSecondary}`} />
                        <h2 className={`text-xl font-semibold mb-2 ${textPrimary}`}>
                            Institutions Screen In Development
                        </h2>
                        <p className={`${textSecondary}`}>
                            This page will display detailed institutional ownership data, including:
                        </p>
                        <ul className={`mt-4 space-y-2 ${textSecondary} text-left max-w-md mx-auto`}>
                            <li className="flex items-start gap-2">
                                <span className="text-blue-500 mt-1">•</span>
                                <span>Top institutional holders by position size</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-blue-500 mt-1">•</span>
                                <span>Ownership concentration metrics</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-blue-500 mt-1">•</span>
                                <span>Recent buying and selling activity</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-blue-500 mt-1">•</span>
                                <span>Historical ownership trends</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-blue-500 mt-1">•</span>
                                <span>13F filing analysis</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Institutions;
